module.exports = __webpack_public_path__ + "img/shuzijuecepingtai.306ab221.png";